export default {
  formFieldName: "Placeholder string",
};
